import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, Form } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { CarrierdeviceService, getCarrierDeviceList, CARRIERDEVICE, DEFAULT_FLOOR } from '../../../service/carrierdevice/carrierdevice.service';
import { LocaService } from 'app/service/loca/loca.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9252',
  templateUrl: 'wa9252.component.html',
  styleUrls: ['wa9252.component.scss']
})
export class Wa9252Component implements OnInit {
  public componentTitle = 'WA9252:搬送什器マスタ登録';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerId: FormControl;
  public carrierdeviceId: number;
  public floorCd: FormControl;
  public carrierdevicetypeCd: FormControl;
  public carrierdeviceTx: FormControl;
  public widthNr: FormControl;
  public depthNr: FormControl;
  public heightNr: FormControl;
  public fillinglimitNr: FormControl;
  public selectedOwnerId: number ;
  public ownerResult;

  public owners: any;
  public locas: any;
  public floors: any; 

  static readonly DEFALUT_SIZENR = 0;
  static readonly DEFAULT_FILLINGLIMITNR = 100;

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Input() selectedownerId;
  @Input() selectedOwnerTx;
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private ownerIdCls = '';
  private floorCdCls = '';
  private carrierdevicetypeCdCls = '';
  private carrierdeviceTxCls = '';
  private widthNrCls = '';
  private depthNrCls = '';
  private heightNrCls = '';
  private fillinglimitNrCls = '';

  private carrierdevices:{ code: number; name: string; }[];

  constructor(
    private ownerService: OwnerService,
    private carrierdeviceService: CarrierdeviceService,
    private locaService: LocaService,
    private commonService: CommonService,
  ) {
    this.ownerId = new FormControl('', [
      Validators.required,
    ]),
    this.floorCd = new FormControl('', [
      Validators.required,
    ]),
    this.carrierdevicetypeCd = new FormControl('', [
      Validators.required,
    ]),
    this.carrierdeviceTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.carrierdeviceTx.maxLength)]);
    this.widthNr = new FormControl(Wa9252Component.DEFALUT_SIZENR, [
      Validators.required,
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.carrierdeviceWidthNr.maxNr),
      Validators.min(validation.carrierdeviceWidthNr.minNr)]);
    this.depthNr = new FormControl(Wa9252Component.DEFALUT_SIZENR, [
      Validators.required,
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.carrierdeviceDepthNr.maxNr),
      Validators.min(validation.carrierdeviceDepthNr.minNr)]);
    this.heightNr = new FormControl(Wa9252Component.DEFALUT_SIZENR, [
      Validators.required,
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.carrierdeviceHeightNr.maxNr),
      Validators.min(validation.carrierdeviceHeightNr.minNr)]);
    this.fillinglimitNr = new FormControl(Wa9252Component.DEFAULT_FILLINGLIMITNR, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.max(validation.fillinglimitNr.maxNr),
      Validators.min(validation.fillinglimitNr.minNr)]);

    // 搬送什器種類の取得
    this.carrierdevices = getCarrierDeviceList();

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // this.working = true;
    this.ownerService
      .get()
      .then(outputJson => {
        try {
          this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
          if (JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {

            this.owners = outputJson.owners.filter((item, index) => {
              if (item.ownerId === JSON.parse(sessionStorage.getItem('ownerResult')).ownerId) return true;
            });
            this.selectedownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
            this.ownerId.setValue(JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx);
            this.ownerResult = sessionStorage.getItem('ownerResult');

          } else {
            this.owners = outputJson.owners;
            this.selectedownerId = null;
            this.ownerResult = sessionStorage.getItem('ownerResult');

            this.ownerId.setValue('');

          }
        } catch (error) {
          this.selectedownerId = null;
        }
      })
      // フロアコードの取得
      this.locaService
      .get()
      .then(_outputJson => {
        this.locas = _outputJson.locas;
        if (this.selectedownerId != null) {
          this.floors = this.getUniqueFloorCd(this.locas, this.selectedownerId);
          console.log(this.floors);
        }
      })
      .catch(error => {
        this.working = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
      });
    }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    let carrierdeviceTx = String(this.carrierdeviceTx.value.trim());
    let fillinglimitNr = this.fillinglimitNr.value / 100;

    let floorCd: string;
    console.log(this.floorCd.value);
    if (this.floorCd.value === DEFAULT_FLOOR) {
      // デフォルトの場合は、空文字を設定する
      floorCd = '';
    } else {
      floorCd = this.floorCd.value.split('-')[1];;
    }
    
    let errors = false;
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.floorCd.errors !== null) {
      this.floorCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.carrierdevicetypeCd.errors !== null) {
      this.carrierdevicetypeCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.carrierdeviceTx.errors !== null) {
      this.carrierdeviceTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.widthNr.errors !== null) {
      this.widthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.depthNr.errors !== null) {
      this.depthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.heightNr.errors !== null) {
      this.heightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.fillinglimitNr.errors !== null) {
      this.fillinglimitNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    if (this.working) return;
    this.working = true;

    let ownerIdValue = this.selectedOwnerId ? this.selectedOwnerId : this.ownerId.value;
    
    this.carrierdeviceService
      .post(
        ownerIdValue,
        floorCd,
        this.carrierdevicetypeCd.value,
        carrierdeviceTx,
        this.widthNr.value,
        this.depthNr.value,
        this.heightNr.value,
        fillinglimitNr,
        'wa9252')
      .then(outputJson => {
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '登録が完了しました');
        }
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    if (this.selectedOwnerId != null) {
        this.selectedOwnerId = null;
    }

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
      let selectedOwnerTx;
      this.ownerService
        .get()
        .then(outputJson => {
          if (this.selectedownerId) {
            this.owners = outputJson.owners.filter((item, index) => {
              if (item.ownerId === this.selectedownerId) {
                this.selectedOwnerId = item.ownerId;
                selectedOwnerTx = item.ownerTx;
                // 荷主が切り替わった場合に、フロアコードを再取得する
                this.floors = this.getUniqueFloorCd(this.locas, this.selectedOwnerId);
                return true;
              }
            });
            this.ownerId.setValue(selectedOwnerTx);
          } else {
            this.owners = outputJson.owners;
            this.ownerId.setValue('');
          }
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.ownerId.setValue('');
    this.floorCd.setValue('');
    this.carrierdevicetypeCd.setValue('');
    this.carrierdeviceTx.setValue('');
    this.widthNr.setValue(Wa9252Component.DEFALUT_SIZENR);
    this.depthNr.setValue(Wa9252Component.DEFALUT_SIZENR);
    this.heightNr.setValue(Wa9252Component.DEFALUT_SIZENR);
    this.fillinglimitNr.setValue(Wa9252Component.DEFAULT_FILLINGLIMITNR);
    this.isSubmitButtonEnabled = false;
    this.enableItems();
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    if(this.ownerId.value === null || this.ownerId.value === '') {
      this.floors = [];
    }

    if ((this.widthNr.value + '').length == 0)
      this.widthNr.setValue(Wa9252Component.DEFALUT_SIZENR);
    if ((this.depthNr.value + '').length == 0)
      this.depthNr.setValue(Wa9252Component.DEFALUT_SIZENR);
    if ((this.heightNr.value + '').length == 0)
      this.heightNr.setValue(Wa9252Component.DEFALUT_SIZENR);
    if ((this.fillinglimitNr.value + '').length == 0) 
      this.fillinglimitNr.setValue(100);
    
    this.ownerIdCls = this.ownerId.disabled ? 'disabled' : this.ownerId.value === '' ? '' : this.STRINGS_ACTIVE;
    this.floorCdCls = this.floorCd.value === '' ? '' : (this.floorCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.carrierdevicetypeCdCls = this.carrierdevicetypeCd.value === '' ? '' : (this.carrierdevicetypeCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.carrierdeviceTxCls = this.carrierdeviceTx.value === '' ? '' : (this.carrierdeviceTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);

    // パレットの場合は、入力不可とする
    if (Number(this.carrierdevicetypeCd.value) === CARRIERDEVICE.PALLET.code) {
        this.widthNrCls = 'disabled';
        this.depthNrCls = 'disabled';
        this.heightNrCls = 'disabled';
        this.fillinglimitNrCls = 'disabled';
    } else {
      this.widthNrCls = this.widthNr.value + '' === '0' ? '' : (this.widthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
      this.depthNrCls = this.depthNr.value + '' === '0' ? '' : (this.depthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
      this.heightNrCls = this.heightNr.value + '' === '0' ? '' : (this.heightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
      this.fillinglimitNrCls = this.fillinglimitNr.value + '' === '100' ? '' : (this.fillinglimitNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    }

    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
    this.ownerIdCls === this.STRINGS_ACTIVE &&
    this.floorCdCls === this.STRINGS_ACTIVE &&
    this.carrierdevicetypeCdCls === this.STRINGS_ACTIVE &&
    this.carrierdeviceTxCls === this.STRINGS_ACTIVE &&
    (this.widthNr.value + '').length > 0 && this.widthNr.errors == null &&
    (this.depthNr.value + '').length > 0 && this.depthNr.errors == null &&
    (this.heightNr.value + '').length > 0 && this.heightNr.errors == null &&
    (this.fillinglimitNr.value + '').length > 0 && this.fillinglimitNr.errors == null;
  }

  clrErr() {
    this.errorInfo = '';
  }

  getUniqueFloorCd(locas: any[], ownerId: number): any {
    const uniqueSet = new Set<string>();
    let hasDefault = false;
  
    const floors: string[] = 
      locas
        .filter((row: any) => Number(row.ownerId) === ownerId)
        .reduce((arr: string[], row: any) => {
          let whCd = row.whCd;
          let floorCd = row.floorCd;
  
          if (!whCd || whCd.trim() === '' || !floorCd || floorCd.trim() === '') {
            // whCd or floorCd is null, blank or undefined
            if (!hasDefault) {
              hasDefault = true;
              arr.unshift(DEFAULT_FLOOR);
            }
          } else {
            const floor = whCd + '-' + floorCd;
            if (!uniqueSet.has(floor)) {
              uniqueSet.add(floor);
              arr.push(floor);
            }
          }
          return arr;
        }, [])
        .sort();
  
    if (!hasDefault) {
      floors.unshift(DEFAULT_FLOOR);
    }

    return floors;
  }
  

  changeOwner(event: { target: { value: string; }; }) {
    this.floors = this.getUniqueFloorCd(this.locas, Number(event.target.value));
    this.floorCd.setValue('');
  }

  changeCarrierdeviceType(event: { target: { value: string; }; }) {
    if (Number(event.target.value) === CARRIERDEVICE.PALLET.code) {
      this.widthNr.setValue(Wa9252Component.DEFALUT_SIZENR);
      this.depthNr.setValue(Wa9252Component.DEFALUT_SIZENR);
      this.heightNr.setValue(Wa9252Component.DEFALUT_SIZENR);
      this.fillinglimitNr.setValue(Wa9252Component.DEFAULT_FILLINGLIMITNR);
      this.widthNr.disable();
      this.depthNr.disable();
      this.heightNr.disable();
      this.fillinglimitNr.disable();
    } else {
      this.enableItems();
    }
  }

  enableItems() {
    this.widthNr.enable();
    this.depthNr.enable();
    this.heightNr.enable();
    this.fillinglimitNr.enable();
  }


}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9252/wa9252.component.ts